import { render, staticRenderFns } from "./ranking-register.vue?vue&type=template&id=79bea1cb&scoped=true&"
import script from "./ranking-register.vue?vue&type=script&lang=js&"
export * from "./ranking-register.vue?vue&type=script&lang=js&"
import style0 from "./ranking-register.vue?vue&type=style&index=0&id=79bea1cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bea1cb",
  null
  
)

export default component.exports